import { DELETE_CIRCLE } from "../actions/circles";
import { DELETE_EVENT } from "../actions/events";
import { DELETE_HUMAN_COMMENT } from "../actions/humanComments";
import { DELETE_HUMAN } from "../actions/humans";
import { DELETED_OBJECTS_COMMIT } from "../actions/sync";

function add(state, key, id) {
  if (typeof state[key] !== "undefined") {
    return {
      ...state,
      [key]: [...state[key], id],
    };
  }

  return { ...state, [key]: [id] };
}

export default function deletedObjects(state = {}, action) {
  switch (action.type) {
    case DELETED_OBJECTS_COMMIT: {
      const newState = {};

      for (const k in state) {
        newState[k] = [];

        for (const id of state[k]) {
          if (!action.deleted[k] || action.deleted[k].indexOf(id) === -1) {
            newState[k].push(id);
          }
        }
      }

      return newState;
    }

    case DELETE_HUMAN: {
      return add(state, "human", action.id);
    }

    case DELETE_HUMAN_COMMENT: {
      return add(state, "humanComment", action.id);
    }

    case DELETE_EVENT: {
      return add(state, "event", action.id);
    }

    case DELETE_CIRCLE: {
      return add(state, "circle", action.id);
    }

    default:
      return state;
  }
}
